import { useState } from 'react';
import { generateAutoStrategy } from '../../services/StrategiesService';
import SelectSymbol from '../../components/SelectSymbol';

/**
 * props:
 * - symbol (opcional, para contexto)
 * - onNotification
 */
function StrategyRecommendationModal(props) {

    const [symbol, setSymbol] = useState(props.symbol || '');
    const [percentage, setPercentage] = useState(10);
    const [targetProfit, setTargetProfit] = useState(2);
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);

    function onSymbolChange(event) {
        setSymbol(event.target.value);
    }

    function onSubmit(event) {
        event.preventDefault();
        
        if (!symbol) {
            if (props.onNotification)
                props.onNotification({ type: 'error', text: 'Selecione um símbolo!' });
            return;
        }

        setLoading(true);
        setResult(null);

        generateAutoStrategy(symbol, percentage, targetProfit)
            .then(data => {
                if (data && data.strategy) {
                    setResult(data);
                    if (props.onNotification)
                        props.onNotification({ 
                            type: 'success', 
                            text: `Estratégia automática criada com sucesso para ${symbol}! ${data.description || ''}` 
                        });
                } else {
                    throw new Error('Resposta inválida do servidor');
                }
            })
            .catch(err => {
                console.error('Erro ao criar estratégia:', err);
                const errorMessage = err.response?.data || err.message || 'Erro desconhecido ao criar estratégia';
                if (props.onNotification)
                    props.onNotification({ type: 'error', text: errorMessage });
            })
            .finally(() => setLoading(false));
    }

    function renderResult() {
        if (!result || !result.strategy) return <></>;

        return (
            <div className="mt-3">
                <div className="alert alert-success">
                    <h6>Estratégia Criada com Sucesso!</h6>
                    <p><b>Símbolo:</b> {result.strategy?.symbol || 'N/A'}</p>
                    <p><b>Nome:</b> {result.strategy?.name || 'N/A'}</p>
                    <p><b>Status:</b> {result.strategy?.isActive ? 'Ativa' : 'Inativa'}</p>
                    <p className="mb-0"><b>Descrição:</b> {result.description || 'Estratégia criada com sucesso.'}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="modal fade" id="modalStrategyRecommendation" tabIndex="-1" role="dialog" aria-labelledby="modalStrategyRecommendationLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content bg-white">
                    <div className="modal-header">
                        <h5 className="modal-title" id="modalStrategyRecommendationLabel">IA - Recomendação de Estratégia</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form onSubmit={onSubmit}>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label className="form-label">Símbolo</label>
                                <SelectSymbol
                                    symbol={symbol}
                                    onChange={onSymbolChange}
                                    disabled={loading}
                                />
                                <div className="form-text">Escolha o par de moedas para a estratégia automática</div>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">
                                    Porcentagem de Trabalho: <strong>{percentage}%</strong>
                                </label>
                                <input
                                    type="range"
                                    className="form-range"
                                    min="1"
                                    max="100"
                                    value={percentage}
                                    onChange={e => setPercentage(parseFloat(e.target.value))}
                                    disabled={loading}
                                />
                                <div className="form-text">Quanto do seu saldo será usado para esta estratégia (1% a 100%)</div>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">
                                    Lucro Alvo: <strong>{targetProfit}%</strong>
                                </label>
                                <input
                                    type="range"
                                    className="form-range"
                                    min="0.1"
                                    max="20"
                                    step="0.1"
                                    value={targetProfit}
                                    onChange={e => setTargetProfit(parseFloat(e.target.value))}
                                    disabled={loading}
                                />
                                <div className="form-text">A venda será executada quando o lucro atingir esta porcentagem (0.1% a 20%)</div>
                            </div>
                            <div className="alert alert-info">
                                <h6 className="alert-heading">Como funciona:</h6>
                                <ul className="mb-0">
                                    <li>A IA cria automaticamente uma estratégia completa usando indicadores técnicos</li>
                                    <li><strong>Compra:</strong> Quando RSI &lt; 30 (oversold) E MACD indica tendência de alta</li>
                                    <li><strong>Venda:</strong> Quando RSI &gt; 70 (overbought) OU lucro &gt;= {targetProfit}%</li>
                                    <li>Monitor, automações e templates são criados automaticamente</li>
                                    <li>A estratégia é ativada automaticamente após criação</li>
                                </ul>
                            </div>
                            {renderResult()}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Fechar</button>
                            <button type="submit" className="btn btn-primary" disabled={loading || !symbol}>
                                {loading ? 'Criando estratégia...' : 'Criar Estratégia Automática'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default StrategyRecommendationModal;



